/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import React, { useContext, useEffect, useRef, useState } from "react";
import { faFolderOpen } from "@fortawesome/free-solid-svg-icons";
import { PropTypes } from "prop-types";
import { useHistory } from "react-router-dom";
import { Formik } from "formik";
import {
  Content,
  Heading,
  ColIcon,
  RowIcon,
  FilterContainer,
  FilterSearchContainer,
  MobileLabel,
  RowFilter,
  CheckBoxColumn,
  FilterColumn,
  FieldGrid,
  Warn
} from "./styles";
import { Icon, Button } from "components/index";
import Row from "components/Grid/Row";
import Col from "components/Grid/Col";
import { Label, SelectField } from "../index";
import Checkbox from '../Form/CheckBox';
import { FitinsurAPI, MessageCenter } from 'utils';
import { GlobalAuthContext } from "store/context";
import Colors from "../../constants/Colors";

const propTypes = {
  title: PropTypes.string,
  children: PropTypes.any,
  icon: PropTypes.bool,
};

export default function ContentCard({
  title,
  children,
  icon,
  info,
  filterContact,
  handleFilterContact,
  hide,
  customColor
}) {
  const fitinsur = new FitinsurAPI();
  const mc = new MessageCenter();
  const authContext = useContext(GlobalAuthContext);
  const history = useHistory();
  const formik = useRef();
  const [showFilter, setShowFilter] = useState(false);
  const [filter, setFilter] = useState("");
  const initialValues = {
    filter: {
      idContactDepartment: "",
    },
  };
  const [contactDepartments, setContactDepartaments] = useState([]);

  const getFormOptions = async () => {
    try {
      fitinsur.setAuthToken(authContext.token);
      const response = await fitinsur.requestGetPersonFormOptions()
        .then(res => res.json());

      if (response.ret_code != 200) {
        mc.error(response.ret_msg_details);
      }

      setContactDepartaments(response.ret_value.contactDepartments);
    } catch (err) {
      mc.error("An error happened, please try again.");
    };
  }

  const handleFilter = (filter) => {
    setFilter(filter.department.idAnswerOption);
  }

  useEffect(() => {
    getFormOptions();
  }, [])

  return (
    <>
      {!hide && <Heading bgColor={customColor}>
        {title ? title : "Content Title"}
        <RowIcon>
          {!icon ? (
            ""
          ) : (
            <ColIcon>
              <div
                onClick={() =>
                  history.push(
                    `/broking/document-management/${info.idOperation}`
                  )
                }
              >
              </div>
            </ColIcon>
          )}
          {filterContact ? (
            <Formik
              initialValues={initialValues}
              innerRef={formik}
            >
              {(formikProps) => (
                <>
                  <FilterContainer className={showFilter ? "filter-open close" : "filter-close"}>
                    <Row>
                      <Col
                        style={{
                          display: "flex",
                          justifyContent: "flex-end",
                        }}
                      >
                        <Icon
                          name="close"
                          className="icon-close"
                          onClick={() => setShowFilter(false)}
                        />
                      </Col>
                    </Row>
                    <FilterSearchContainer>
                      <Row>
                        <MobileLabel>FILTER</MobileLabel>
                      </Row>
                      <RowFilter>
                        <CheckBoxColumn>
                          <Label>
                            <Checkbox
                              checked={formikProps.values.filter.idContactDepartment}
                              onChange={() => { formik.current.setFieldValue("filter.idContactDepartment", ""); setFilter("") }}
                            />
                          </Label>
                        </CheckBoxColumn>
                        <FilterColumn>
                          <FieldGrid
                            name="filter.idContactDepartment"
                            placeholder="Contact Department"
                            component={SelectField}
                            options={contactDepartments.map((contact) => ({
                              label: contact.description,
                              value: { ...contact }
                            }))}
                            onChange={(department) => handleFilter({ department })}
                          />
                        </FilterColumn>
                      </RowFilter>
                    </FilterSearchContainer>

                    <Row align="center" className='apply-button-container'>
                      <Col>
                        <Button
                          primary
                          type="button"
                          id="btnFilter"
                          style={{ textAlign: "center" }}
                          onClick={(e) => {
                            e.stopPropagation();
                            e.preventDefault();
                            handleFilterContact(filter);
                            setShowFilter(false);
                          }}
                        >
                          Apply
                        </Button>
                      </Col>
                    </Row>
                  </FilterContainer>

                  <ColIcon>
                    <Icon name="filter" onClick={() => setShowFilter(!showFilter)} />
                  </ColIcon>
                  <ColIcon>
                    <Icon name="filterCan" onClick={() => {
                      handleFilterContact("");
                      formik.current.setFieldValue("filter.idContactDepartment", "");
                      setFilter("")
                    }}
                    />
                  </ColIcon>
                </>
              )}
            </Formik>
          ) : (
            <></>
          )}
        </RowIcon>
      </Heading>}
      <Content hide={hide} borderColor={customColor}>{children}</Content>
    </>
  );
}

ContentCard.propTypes = propTypes;
